import { useDispatch } from 'react-redux';
import GlobalTableGenerator from '../../../../../components/GlobalTableGenerator';
import { dailyViewTableHead } from '../utils/tableHeaders';
import { useEffect } from 'react';
import { fetchAttendanceData } from '../../../../../redux/features/crdMigrationSlice';
import { useSelector } from 'react-redux';

export default function DailyView({ row, yearAndMonth }) {
  const dispatch = useDispatch();
  useEffect(() => {
    const params = {
      course_enrollment_id: row?.course_enrollment_id,
      trainer_id: row?.trainer_id,
      attendance_date: `${yearAndMonth}-${row?.date}`,
    };
    dispatch(fetchAttendanceData(params));
  }, [row, dispatch, yearAndMonth]);

  const dailyViewTable = useSelector((state) => state.crdMigration.attendanceSingleViewTable.data);
  const loading = useSelector((state) => state.crdMigration.attendanceSingleViewTable.loading);

  console.log({ dailyViewTable });

  return (
    <GlobalTableGenerator
      columns={dailyViewTableHead}
      loading={loading}
      rows={dailyViewTable}
      TableStyle={{
        borderCollapse: 'collapse',
        '& .MuiTableCell-root': {
          border: '1px solid #ffffffff',
        },
      }}
      pagination
      TableHeadStyle={{
        bgcolor: '#dadee2ff',
        '& .muitablecell-root': {
          fontweight: 600,
        },
      }}
    />
  );
}
